import axios from "axios";
import { resolveBackendUrl, AUTH_MODE } from "@/config";

const BACKEND_URL = resolveBackendUrl();

export const api = axios.create({ baseURL: `${BACKEND_URL}/api` });

// Request interceptor: attach auth headers based on mode
api.interceptors.request.use((config) => {
  const token = sessionStorage.getItem("via_token");

  if (AUTH_MODE === "demo") {
    // Demo mode: send X-User-Id header from localStorage (backward compat)
    const agpUser = localStorage.getItem("agp_user");
    if (agpUser) {
      try {
        const u = JSON.parse(agpUser);
        config.headers["X-User-Id"] = u.id;
      } catch { /* noop */ }
    }
    // Also try sessionStorage via_user as fallback for demo
    if (!config.headers["X-User-Id"]) {
      const raw = sessionStorage.getItem("via_user");
      if (raw) {
        try {
          const u = JSON.parse(raw);
          config.headers["X-User-Id"] = u.id;
        } catch { /* noop */ }
      }
    }
  } else {
    // JWT / Entra mode: send Bearer token
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
  }

  return config;
});

// Response interceptor: on 401, clear session and redirect to login
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      sessionStorage.removeItem("via_token");
      sessionStorage.removeItem("via_user");
      // Only redirect if not already on login page to avoid loops
      if (!window.location.pathname.startsWith("/login")) {
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);

// apiError extrae el mensaje de error legible de una respuesta de axios.
// Lee tanto `detail` (clave de los handlers del paquete handler) como `error`
// (clave que usa el middleware de auth para 401/403); sin esta segunda rama la
// UI tragaba los rechazos de permisos/sesión y los mostraba como genéricos.
export const apiError = (e) =>
  e?.response?.data?.detail ||
  e?.response?.data?.error ||
  e?.message ||
  "Error inesperado";
